import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const accountProfile = lazyWithRetry(() => import("./routes/profile"));

const accountProfileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/account/profile",
  component: () => renderProtectedRoute(accountProfile),
});

export const accountRouteTree = [accountProfileRoute];
